// the css is injected automatically
require('!style-loader!css-loader!postcss-loader!stylus-loader!./models.styl');

// this helps us remove everything exepct whats inside the body node
var strip = require("striphtml");

var getData = require('../../scripts/getdata')(MBGF.mbfa_apibase);
var validation = require('validation')(getData).models;
var parsing = require('parsing').models;

// event handler
var nunt = require("lib/nunt");
var dropdown = require("../dropdown/dropdown");

var dataSource = "";
var moduleData = false;

function parse(text, next) {
    strip(require('raw!./models.html'), function(outputHtml) {
        // if the text after ":" isnt pc,van,smart or truck it is considered to be one or many id
        var match = parsing.parse(text);

        var options;

        if (match) {
            var that = this;

            var requireData = "models";

            if (match[2]) {
                requireData += "?values=" + match[2];
            }
            else if (match[1]) {
                requireData += "?group=" + match[1];
            }


            getData(requireData, function(jsonString) {
                // check if the datasource is to be overridden

                if (that.dataSource && that.dataSource != "") {
                    jsonString = that.dataSource;
                }

                try {
                    if (typeof jsonString == "object") {
                        options = jsonString;
                    }
                    else {
                        options = JSON.parse(jsonString);
                    }
                }
                catch (e) {
                    options = false;
                }

                moduleData = options;

                var insertOptions = "";

                if (options) {
                    //console.log(options);

                    var grouped = {};
                    var array = [];
                    for (var i = 0; i < options.length; i++) {
                        array[i] = options[i].value + " -> " + options[i].label;

                        if (options[i].selected) {
                            array[i] = "(" + array[i] + ")";
                        }
                    }

                    insertOptions = array.join(",");
                }

                var container = document.createElement("div");
                container.innerHTML = outputHtml;
                var domObj = container.firstChild;

                insertOptions = 'null -> ' + domObj.getAttribute('data-default-label').replace('{{', '').replace('}}', '') + ',' + insertOptions;

                outputHtml = outputHtml.replace("{}", "{" + insertOptions + "}");

                if (match[3] == "*") {
                    container.innerHTML = outputHtml;
                    domObj = container.firstChild;

                    // add a "required" class to the parent node
                    domObj.setAttribute("class", domObj.getAttribute("class") + " required");
                    domObj.setAttribute("data-required", "true");

                    outputHtml = container.innerHTML.replace(" = {", "* = {");
                }

                text = text.replace(match[0], outputHtml);
                next(text);
            });
        }
        else {
            next(text);
        }
    });

};

function validate(context, err) {
    var value = get(context);
    var required = context.getAttribute("data-required") == "true";
    var input = context.querySelector("select");

    var currentClasses = input.getAttribute("class") || "";
    currentClasses = currentClasses.replace(/(|\s)valid(|\s)/g, "").replace(/(|\s)error(|\s)/g, "");

    var messagelabel = context.querySelector("#txt_models-error");
    messagelabel.innerHTML = "";

    var formOpts = {
        useKindOfCar: MBGF.useKindOfCar || false, 
        overrideKindOfCar: MBGF.overrideKindOfCar || ''
    };

    return validation.validate(value, required, false, formOpts)
        .then(function(validationResult) {
            validationResult = !err ? validationResult : err;
            dropdown.validate(context);

            if (!validationResult.valid) {
                input.setAttribute("class", currentClasses + " error");
                var message = document.createTextNode(context.getAttribute("data-msg-required"));
                messagelabel.appendChild(message);
                messagelabel.setAttribute("class", " error");
            }
            else {
                input.setAttribute("class", currentClasses + " valid");
                var message = document.createTextNode(context.getAttribute("data-msg-valid"));
                messagelabel.appendChild(message);
                messagelabel.setAttribute("class", " valid");
            }

            return validationResult.valid;
        });
}

function init( formRoot, meta, next ) {
    var modelsOverrideForm = document.querySelector('#form-select-model');
    var context = formRoot.querySelector('[data-module="models"]');

    if( modelsOverrideForm && context ) {
        var input = context.querySelector('select');
        var currentClass = context.getAttribute('class') || '';
        context.setAttribute('class', currentClass + ' hidden');

        // a form that overrides this module visually exists
        var modelRadioButtons = document.querySelectorAll('input[name="car-model"]');

        for(i = 0, ii = modelRadioButtons.length; i < ii; i++) {
            modelRadioButtons[i].addEventListener('change', function() {
                input.value = this.value;
            });
        }
    }

    next(formRoot);
}

function get(context) {
    var modelsOverrideForm = document.querySelector('#form-select-model');

    if( modelsOverrideForm ) {
        var value = modelsOverrideForm.querySelector('input[name="car-model"]:checked').value;
    }
    else {
        var value = dropdown.get(context);
    }
    return value;
}

function reset(context) {
    var modelsOverrideForm = document.querySelector('#form-select-model');

    if( modelsOverrideForm ) {
        var input = modelsOverrideForm.querySelector('input[name="car-model"]:checked').value;
        input.checked = false;
    }
    else {
        dropdown.reset(context);
    }
}

function data(value) {

    var res = moduleData;

    if( value && moduleData ) {
        for( var i = 0, ii = moduleData.length; i < ii; i++ ) {
            if( value == moduleData[i].value ) {
                res = moduleData[i];
                break;
            }
        }
    }

    return res;
}

module.exports = {
    parse: parse,
    validate: validate,
    dataSource: dataSource,
    data: data,
    init: init,
    get: get,
    reset: reset
};



// WEBPACK FOOTER //
// ./js-src/markdown-editor/modules/models/models.js